import { api } from "@/lib/api/client";
import type { components } from "@/types/api";

export type CliAuthorizationMetadata = components["schemas"]["CliAuthorizationMetadata"];
export type CliDevice = components["schemas"]["CliDevice"];
export type CliApprovalResponse = components["schemas"]["CliApprovalResponse"];
export type CliDenialResponse = components["schemas"]["CliDenialResponse"];
export type CliDeviceList = components["schemas"]["CliDeviceList"];

export const REAUTH_REQUIRED_CODE = "reauth_required";

export const MFA_SETUP_REQUIRED_CODE = "mfa_setup_required";

export function getCliAuthorization(authorizationId: string): Promise<CliAuthorizationMetadata> {
  return api.get<CliAuthorizationMetadata>(
    `/v1/cli/authorizations/${encodeURIComponent(authorizationId)}`,
  );
}

export function resolveActivationCode(userCode: string): Promise<CliAuthorizationMetadata> {
  return api.post<CliAuthorizationMetadata>("/v1/cli/activate", { userCode }, { retrySafe: true });
}

export function approveCliAuthorization(authorizationId: string): Promise<CliApprovalResponse> {
  return api.post<CliApprovalResponse>(
    `/v1/cli/authorizations/${encodeURIComponent(authorizationId)}/approve`,
  );
}

export function denyCliAuthorization(authorizationId: string): Promise<CliDenialResponse> {
  return api.post<CliDenialResponse>(
    `/v1/cli/authorizations/${encodeURIComponent(authorizationId)}/deny`,
  );
}

export function listCliDevices(): Promise<CliDeviceList> {
  return api.get<CliDeviceList>("/v1/cli/devices");
}

export function revokeCliDevice(credentialId: string): Promise<void> {
  return api.delete<void>(`/v1/cli/devices/${encodeURIComponent(credentialId)}`);
}
